// SITE CREDIT
console.log(
	'%cSite by View Source \n%cview-source.com',
	[
		'margin: 20px 0 0;',
		'font-size: 12px',
		'font-family: Helvetica, sans-serif',
		'font-weight: 700',
	].join(';'),
	[
		'margin: -5px 0 20px;',
		'font-size: 12px',
		'font-family: Helvetica, sans-serif',
		'font-weight: 400',
	].join(';')
);

// GLOBAL VARIABLES
(function () {
	let localTestKey = 'test';
	let localStorage = window.sessionStorage;

	try {
		localStorage.setItem(localTestKey, 1);
		localStorage.removeItem(localTestKey);
		return localStorageName in win && win[localStorageName];
	} catch (e) {
		hasLocalStorage =
			e.code === DOMException.QUOTA_EXCEEDED_ERR && localStorage.length === 0
				? false
				: true;
	}
})();

let isTablet = 900 < innerWidth ? false : true;
let isMobile = 600 < innerWidth ? false : true;

window.addEventListener('resize', () => {
	isTablet = 900 < innerWidth ? false : true;
	isMobile = 600 < innerWidth ? false : true;
});

// OUTPUTS
const getRandomInt = (min, max) => {
	let _min = Math.ceil(min);
	let _max = Math.floor(max);

	// The maximum is inclusive and the minimum is inclusive
	return Math.floor(Math.random() * (_max - _min + 1) + _min);
};

function getRandomNum(min, max) {
	return Math.random() * (max - min) + min;
}

const getOffset = (el) => {
	let elBounding = el.getBoundingClientRect();

	return {
		top: elBounding.top + scrollY,
		left: elBounding.left + scrollX,
	};
};

const getSiblings = (elem) => {
	return Array.from(elem.parentNode.children).filter(function (sibling) {
		return sibling !== elem;
	});
};

const getBrowser = () => {
	if (
		(navigator.userAgent.indexOf('Opera') ||
			navigator.userAgent.indexOf('OPR')) != -1
	) {
		return 'Opera';
	} else if (navigator.userAgent.indexOf('Chrome') != -1) {
		return 'Chrome';
	} else if (navigator.userAgent.indexOf('Safari') != -1) {
		return 'Safari';
	} else if (navigator.userAgent.indexOf('Firefox') != -1) {
		return 'Firefox';
	} else if (
		navigator.userAgent.indexOf('MSIE') != -1 ||
		!!document.documentMode === true
	) {
		return 'IE'; //crap
	} else {
		return 'Unknown';
	}
};

// FORMATTING
const formatLeadingZero = (val) => {
	return (val < 10 ? '0' : '') + val;
};

const formatPadToDigits = (val, length = 2, char = '0') => {
	// examples:
	// 8 = "08"
	// 000088885581 = "********5581"
	return val.toString().padStart(length, char);
};

const formatToDecimals = (num, dec = 2) => {
	return Number(parseFloat(num).toFixed(dec));
};

const formatHandleize = (str) => {
	return str
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/-$/, '')
		.replace(/^-/, '');
};

const formateDateUsStandard = (date) => {
	return [
		formatPadToDigits(date.getDate()),
		formatPadToDigits(date.getMonth() + 1),
		date.getFullYear(),
	].join('/');
};

// VALIDATION
const validateEmail = (email) => {
	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
		return true;
	}

	return false;
};

// ACTIONS
let scrollPosition = 0;
const scrollDisable = () => {
	// Save the current scroll position
	
	// Add styles to the body to prevent scrolling
	document.documentElement.style.overflow = "hidden";
	document.body.style.overflow = "hidden";
	// scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
	// document.body.style.width = '100%';
	// document.body.style.top = `-${scrollPosition}px`;
};

const scrollEnable = () => {
	document.documentElement.style.overflow = "initial";
	document.body.style.overflow = "initial";
	// Remove the styles added to the body to allow scrolling
	// document.body.style.position = '';
	// document.body.style.width = '';
	// document.body.style.top = '';
	// // Restore the previous scroll position
	// window.scrollTo(0, scrollPosition);
};

// event delegation
// example; on('body', 'click', '.accordion-toggle, .accordion-toggle *', e => {…});
const on = (selector, eventType, childSelectors, eventHandler) => {
	let _childSelectors = childSelectors.split(',');
	let elements = document.querySelectorAll(selector);

	for (element of elements) {
		element.addEventListener(eventType, (eventOnElement) => {
			_childSelectors.forEach((selector) => {
				if (
					eventOnElement.target.matches(selector) ||
					eventOnElement.target.closest(selector)
				) {
					eventHandler(eventOnElement);
				}
			});
		});
	}
};

const slide = (action, el, duration = 400) => {
	const slideDown = () => {
		let childrenHeight = Object.values(el.children).reduce(
			(total, i) => total + i.offsetHeight,
			0
		);

		// Apply active state
		el.classList.add('is-active');
		el.style.height = 'auto';

		// Set the height of the content as 0px
		// so we can trigger the slide down animation.
		el.style.height = '0px';

		// Do this after the 0px has applied.
		// It's like a delay or something. MAGIC!
		setTimeout(() => {
			el.style.height = `${childrenHeight}px`;
			el.style.transition = `height ${duration}ms`;
		}, 0);
	};

	const slideUp = () => {
		// Set the height as 0px to trigger the slide up animation.
		el.classList.remove('is-active');
		el.style.height = '0px';
		el.style.transition = `height ${duration}ms`;

		// Remove the active state when the animation ends
		el.addEventListener(
			'transitionend',
			() => {
				el.style.transition = `0s`;
			},
			{ once: true }
		);
	};

	switch (action) {
		case 'down':
			slideDown();
			break;

		case 'up':
			slideUp();
			break;

		case 'toggle':
			!el.classList.contains('is-active') ? slideDown() : slideUp();
			break;
	}
};

throttleWaiting = {};
const throttle = (callback, limit, id = 0) => {
	throttleWaiting[id] =
		throttleWaiting[id] === undefined ? false : throttleWaiting[id];

	if (!throttleWaiting[id]) {
		callback();
		throttleWaiting[id] = true;
		setTimeout(function () {
			throttleWaiting[id] = false;
		}, limit);
	}
};

let th = ['', 'thousand', 'million', 'billion', 'trillion'];
let dg = [
	'zero',
	'one',
	'two',
	'three',
	'four',
	'five',
	'six',
	'seven',
	'eight',
	'nine',
];
let tn = [
	'ten',
	'eleven',
	'twelve',
	'thirteen',
	'fourteen',
	'fifteen',
	'sixteen',
	'seventeen',
	'eighteen',
	'nineteen',
];
let tw = [
	'twenty',
	'thirty',
	'forty',
	'fifty',
	'sixty',
	'seventy',
	'eighty',
	'ninety',
];

function toWords(s) {
	s = s.toString();
	s = s.replace(/[\, ]/g, '');
	if (s != parseFloat(s)) return 'not a number';
	let x = s.indexOf('.');
	if (x == -1) x = s.length;
	if (x > 15) return 'too big';
	let n = s.split('');
	let str = '';
	let sk = 0;
	for (let i = 0; i < x; i++) {
		if ((x - i) % 3 == 2) {
			if (n[i] == '1') {
				str += tn[Number(n[i + 1])] + ' ';
				i++;
				sk = 1;
			} else if (n[i] != 0) {
				str += tw[n[i] - 2] + ' ';
				sk = 1;
			}
		} else if (n[i] != 0) {
			str += dg[n[i]] + ' ';
			if ((x - i) % 3 == 0) str += 'hundred ';
			sk = 1;
		}
		if ((x - i) % 3 == 1) {
			if (sk) str += th[(x - i - 1) / 3] + ' ';
			sk = 0;
		}
	}
	if (x != s.length) {
		let y = s.length;
		str += 'point ';
		for (let i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
	}
	return str.replace(/\s+/g, ' ');
}

let timerId;
function debounce(func, delay) {
	// Cancels the setTimeout method execution
	clearTimeout(timerId);

	// Executes the func after delay time.
	timerId = setTimeout(func, delay);
}
